import { useCallback } from 'react';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';
import { Storage } from '@/core/services/Storage';

const storage = new Storage('color-schema');
const getStoredKey = (orgId: string) => `schema_key_${orgId}`;

export const useIncidentSchemaKeyStore = () => {
  const { orgId } = useCurrentUser();

  const setIncidentSchemaKey = useCallback((value: string) => storage.setValue(getStoredKey(orgId), value), [orgId]);
  const getIncidentSchemaKey = useCallback((): string | null => storage.getValue(getStoredKey(orgId)), [orgId]);

  return { setIncidentSchemaKey, getIncidentSchemaKey };
};
